Pagination metadata for a result list.

This is compliant with the _Relay Cursor Connections Specification_:

[https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo](https://facebook.github.io/relay/graphql/connections.htm#sec-undefined.PageInfo)
